export const LP_TOKEN_DECIMALS = 18;
